import "./main.css"
import Alpine from "alpinejs"

let htmx: typeof import("htmx.org").default;
(async function main() {
  const htmxModule = await import('htmx.org');
  htmx = htmxModule.default;

  (window as any).htmx = htmx;
  (window as any).Alpine = Alpine

  
  // If you ever need to add HTMX extensions (using response-targets extension as an example here):
  // Install it using `yarn add htmx-ext-response-targets`
  // uncomment the following line:
  // await import("htmx-ext-response-targets")
  
  // Custom HTMX extensions can be defined here
  
  // Finish with processing the new document
  htmx.process(document.body)

  document.addEventListener('alpine:init', () => {

    function perfectlyPositionedBackgroundPercentage() {
      // Returns the exact value for background-position-y to center the logo perfectly for when the user scrolls down to the site's content
      return ((document.body.clientHeight - (document.body.clientWidth * 0.27)) / (document.body.clientHeight - document.body.clientWidth)) * 100
    }

    const bannerCutoffPoint = screen.height * 0.66
    const scrollPercentage = (window.scrollY / bannerCutoffPoint) * 100

    Alpine.data(`header`, () => ({
      x: 50,
      y: window.scrollY >= bannerCutoffPoint ? perfectlyPositionedBackgroundPercentage() : 50,
      zoom: scrollPercentage < 30 ? 30 : scrollPercentage > 100 ? 100 : scrollPercentage,

      init() {

        if(window.location.pathname !== `/`) {
          this.scrollDown()
        }

        let currentArrowIndex = 0

        const getG = (element: Element | undefined): SVGElement | undefined => element?.querySelector(`g`)?.querySelector(`g`) ?? undefined

        setInterval(() => {
          const arrows = [...this.$refs.arrows.children]
          const totalArrows = arrows.length
          const currentArrow = getG(arrows.at(currentArrowIndex))
          if(currentArrow !== undefined) {
            currentArrow.style.opacity = `0%`
          }

          const nextArrowIndex = (currentArrowIndex + 1) % totalArrows
          const nextArrow = getG(arrows.at(nextArrowIndex))
          if(nextArrow !== undefined) {
            nextArrow.style.opacity = `100%`
          }

          currentArrowIndex = nextArrowIndex
        }, 1000)
      },

      rangeTransform: (value: number, range1: [number, number], range2: [number, number]) => {
        // (-100 - 0) / (100 - 0) == -1
        const scale = (range2[1] - range2[0]) / (range1[1] - range1[0])
        // (33 - 0) * -1 + 0 == -33
        const ret = (value - range1[0]) * scale + range2[0]
        // -100 - 0 >= 0
        if(range2[1] - range2[0] >= 0) {
          return ret < range2[0] ? range2[0] : ret > range2[1] ? range2[1] : ret
        } else {
          // -33 > 0 ? 0 : -33 < -100 ? -100 : -33
          return ret > range2[0] ? range2[0] : ret < range2[1] ? range2[1] : ret
        }
      },

      perfectlyPositionedBackgroundPercentage() {
        return perfectlyPositionedBackgroundPercentage()
      },

      scroll(event: Event) {
        const target = event.target as Document
        const scroll = (target.scrollingElement?.scrollTop ?? 0)
        const scrollLimit = bannerCutoffPoint
        const percentage = scroll / scrollLimit

        this.zoom = this.rangeTransform(percentage, [0, 0.63], [30, 100])
        // console.log(this.zoom, this.rangeTransform(this.zoom, [0, 100], [this.x, 50]), this.rangeTransform(this.zoom, [0, 100], [0, -25]))
      },
  
      move(event: MouseEvent) {

        const divTarget = this.$refs.movementzone
        const width = divTarget.clientWidth
        const height = divTarget.clientHeight

        this.x = (event.x / width) * 10 + 45
        this.y = (event.y / height) * 10 + 45
  
      },

      scrollDown() {
        window.scrollTo(0, bannerCutoffPoint)
      }
    }))
  })

  Alpine.start()

})()

export { htmx }